import { createSlice } from "@reduxjs/toolkit";
const url = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;

// Initial state
const initialState = {
  currentChannel: null,
  lastUpdated: null,
};

// Redux slice
const commandsSlice = createSlice({
  name: "commands",
  initialState,
  reducers: {
    setCurrentChannel(state, action) {
      state.currentChannel = action.payload.currentChannel;
    },
  },
});

export const { setCurrentChannel } = commandsSlice.actions;
export default commandsSlice.reducer;

// Async function to fetch and process EPG data
export const findChannel = (search) => async (dispatch, getState) => {
    const state = getState();
    const channels = state.media.playlistData;
    const foundChannel = channels.find((channel) => channel.name.toLowerCase().includes(search));
    window.location.href = `${url}#/live/category/${foundChannel.category_id}/channel/${foundChannel.num}/`;
    //setCurrentChannel(channelNumber);
};
